"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractAuthClient = void 0;
const ConfirmationPasswordNotMatchingError_1 = require("../Error/ConfirmationPasswordNotMatchingError");
const AuthErrorHandleService_1 = require("../Service/HttpClient/AuthErrorHandleService");
class AbstractAuthClient {
    constructor(params) {
        this.httpClientDefaultConfig = {
            baseURL: params.baseURL,
            headers: {
                ...(params.headers ?? {}),
                Accept: 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Content-Type': 'application/json',
                Pragma: 'no-cache',
                'X-Request-With': 'XMLHttpRequest',
            },
            timeout: params.timeout ?? 5000,
        };
    }
    async loginResponse(params) {
        try {
            const { data } = await this.httpClient.post('/v3/login', {
                email: params.email,
                included_authorizations: params.includedAuthorizations,
                password: params.password,
                remember_me: params.rememberMe,
            });
            return {
                refreshToken: data.refresh_token,
                token: data.token,
            };
        }
        catch (error) {
            throw AuthErrorHandleService_1.AuthErrorHandleService.handleAuthResponseError(error);
        }
    }
    async refreshTokenResponse(params) {
        try {
            const { data } = await this.httpClient.post('/v3/login/refresh_token', {
                included_authorizations: params.includedAuthorizations,
                refresh_token: params.refreshToken,
            });
            return {
                refreshToken: data.refresh_token,
                token: data.token,
            };
        }
        catch (error) {
            throw AuthErrorHandleService_1.AuthErrorHandleService.handleRefreshResponseError(error);
        }
    }
    async changePasswordResponse(params, accessToken) {
        const { confirmationPassword, newPassword, currentPassword, includedAuthorizations } = params;
        if (confirmationPassword !== newPassword)
            throw new ConfirmationPasswordNotMatchingError_1.ConfirmationPasswordNotMatchingError();
        try {
            const { data } = await this.httpClient.patch('/v3/login/change_password', {
                currentPassword,
                included_authorizations: includedAuthorizations,
                newPassword,
            }, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return {
                refreshToken: data.refresh_token,
                token: data.token,
            };
        }
        catch (error) {
            throw AuthErrorHandleService_1.AuthErrorHandleService.handleChangePasswordResponseError(error);
        }
    }
}
exports.AbstractAuthClient = AbstractAuthClient;
//# sourceMappingURL=AbstractAuthClient.js.map